import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'export-data-dialog',
    templateUrl: 'export-data-dialog.component.html',
    styleUrls: ['export-data-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ExportDataDialogComponent implements OnInit {
  sourceFields: string[] = [];
  targetFields: string[] = [];
  disabledFields: string[] = [];

  form = new FormGroup({
    selectSource:new FormControl(),
    selectTarget:new FormControl()
  });

  constructor(
    public dialogRef: MatDialogRef<ExportDataDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.sourceFields = this.data.sourceFields || [];
    this.targetFields = this.data.targetFields || [];
    this.disabledFields = this.data.disabledFields || [];
  }

  disabledExport() {
      return false;
  }

  onExport() {
      const result = {
          fields: this.targetFields
      }
      this.dialogRef.close(result);  // Optionally close the dialog
  }

  addField() {
      const selectedFields = this.form.controls['selectSource'].value;

      // Add selected fields to targetFields
      this.targetFields.push(...selectedFields);

      // Remove selected fields from sourceFields
      this.sourceFields = this.sourceFields.filter(field => !selectedFields.includes(field));

      // Clear the selection
      this.form.controls['selectSource'].setValue([]);
  }

  removeField() {
      const selectedFields = this.form.controls['selectTarget'].value;

      // Add selected fields back to sourceFields
      this.sourceFields.push(...selectedFields);

      // Remove selected fields from targetFields
      this.targetFields = this.targetFields.filter(field => !selectedFields.includes(field));

      // Clear the selection
      this.form.controls['selectTarget'].setValue([]);
  }



  disabledField(field) {
      return this.disabledFields.includes(field);
  }

  disabledAddRemove(selectForm) {
      const selectedFields = this.form.controls[selectForm].value;
      return !selectedFields;
  }
}
